import { Navigate, Outlet } from 'react-router-dom';
import { isAuthenticated } from 'utils/authentication';
import { BackgroundColorContainer, MainDiv } from 'components/styles_components/container';
import { MenuProvider } from 'contexts/menu';
import MainContainer from 'components/layout/main_container';

const PrivateNoSpaceRoute = () => {
  if (isAuthenticated()) {
    return (
      <BackgroundColorContainer>
        <MainDiv>
          <MainContainer>
            <MenuProvider>
              <Outlet />
            </MenuProvider>
          </MainContainer>
        </MainDiv>
      </BackgroundColorContainer>
    );
  }
  return <Navigate to="/users/login" />;
};

export default PrivateNoSpaceRoute;
